"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import classNames from "classnames";
import styles from "./ErrorPage.module.css";
import { ReactComponent as BadRobot } from "./assets/bad-robot.svg";
import { ReactComponent as Ground } from "./assets/ground.svg";
export const ErrorPage = (props) => {
  const { className } = props;
  useEffect(() => {
    console.error("mission error");
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: classNames(styles.root, "pageNotFound", className), children: [
    /* @__PURE__ */ jsxs("div", { className: classNames(styles.errorContainer, "errBlock"), children: [
      /* @__PURE__ */ jsx("p", { className: classNames(styles.errorCode, "errCode"), children: "Mission error, JUDI is stuck! Refreshing the page should resolve this issue." }),
      /* @__PURE__ */ jsx("p", { className: classNames(styles.errorMessage, "errMsg"), children: "Refresh didn't work? Try quitting and reopening your browser, then logging in again. If JUDI still doesn't load, we may be having internal technical issues. Our deepest apologies!" })
    ] }),
    /* @__PURE__ */ jsx(BadRobot, { className: classNames(styles.errorRobot, "robot") }),
    /* @__PURE__ */ jsx("div", { className: classNames(styles.errorBackground, "background"), children: /* @__PURE__ */ jsx(Ground, { className: classNames(styles.errorGround, "ground") }) })
  ] });
};
